import { render, staticRenderFns } from "./Quote2.vue?vue&type=template&id=a06858da&scoped=true&"
import script from "./Quote2.vue?vue&type=script&lang=js&"
export * from "./Quote2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a06858da",
  null
  
)

export default component.exports